module.exports = __webpack_public_path__ + "img/logIn-registration.fb04ac5c.png";